import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaIndustry } from 'react-icons/fa';
import { reachGoal } from '../utils/metrika';
import './Footer.css';

const links = [
  { label: 'Главная', to: '/' },
  { label: 'Конфигуратор', to: '/configurator' },
  { label: 'Кейсы', to: '/cases' },
  { label: 'Сертификаты', to: '/certificates' },
  { label: 'Политика конфиденциальности', to: '/privacy' },
];

const Footer = () => (
  <footer className="footer">
    <div className="container-custom">
      <div className="footer-grid">
        <div className="footer-brand">
          <img src="/logo.png" alt="Орион" className="footer-logo" />
          <p>Производство шкафов и корпусов из нержавеющей стали AISI 304/316. Комплексные поставки электротехнического оборудования.</p>
        </div>

        <nav className="footer-col" aria-label="Разделы сайта">
          <h3 className="footer-title">Разделы</h3>
          {links.map((link) => (
            <Link key={link.to} to={link.to} className="footer-link">{link.label}</Link>
          ))}
        </nav>

        <div className="footer-col">
          <h3 className="footer-title">Контакты</h3>
          <span className="footer-link">
            <FaPhone />
            <a href="tel:+78122373834" draggable={false} onClick={() => reachGoal('clc-tel1')}>+7 812 237-38-34</a>
          </span>
          <span className="footer-link">
            <FaEnvelope />
            <a href="mailto:agoratech@mail.ru" draggable={false}>agoratech@mail.ru</a>
          </span>
          <span className="footer-link footer-address">
            <FaMapMarkerAlt /> Склад: 196158, г. Санкт-Петербург, Московское шоссе, 23АБ
          </span>
          <span className="footer-link footer-address">
            <FaIndustry /> Производство: г. Нижний Новгород, пос. Черепичный, 2а
          </span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
